import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import setPath from 'lodash/set';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import Colors from '../styles/colors';
import { BaseButton } from '../styles/styled';

class AlertConfirmDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      title: props.title,
      content: null,
      actions: {
        ok: {
          show: true,
          text: 'OK',
          click: () => {},
        },
        cancel: {
          show: true,
          text: 'CANCEL',
          click: () => {},
        },
      },
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.set = this.set.bind(this);
    this.action = this.action.bind(this);
    this.actionHandler = this.actionHandler.bind(this);
  }

  set(statekey, stateval) {
    this.setState({
      [statekey]: stateval,
    });

    return this;
  }

  action(actionpath, actionval) {
    const { actions } = this.state;
    const nactions = { ...actions };
    const value = setPath(nactions, actionpath, actionval);
    return this.set('actions', value);
  }

  actionHandler(complete, value) {
    return async () => {
      await this.close();
      // if (value) {
      //   await this.completeAnimation();
      // }

      complete(value);
    };
  }

  alert(content = '') {
    return new Promise(resolve => {
      this.action('cancel.show', false);
      this.action('ok.show', true);
      this.action('ok.click', this.actionHandler(resolve));
      this.setState(({ show }) => {
        return {
          content,
          show: !show,
        };
      });
    });
  }

  confirm(content = '') {
    return new Promise(resolve => {
      this.action('cancel.show', true);
      this.action('cancel.click', this.actionHandler(resolve, false));
      this.action('ok.show', true);
      this.action('ok.click', this.actionHandler(resolve, true));
      this.setState(({ show }) => {
        return {
          content,
          show: !show,
        };
      });
    });
  }

  completeAnimation() {
    return new Promise(resolve => setTimeout(resolve, 450));
  }

  toggle() {
    return new Promise(resolve => {
      this.setState(({ show }) => {
        return { show: !show };
      }, resolve);
    });
  }

  open() {
    return this.toggle();
  }

  close() {
    return this.toggle();
  }

  renderCancelBtn() {
    const { actions } = this.state;
    const { show, text, click } = actions.cancel;

    if (!show) {
      return null;
    }

    return (
      <CancelButton onClick={click} className="btn text-medium margin-two-right">
        {text}
      </CancelButton>
    );
  }

  renderSubmitBtn() {
    const { actions } = this.state;
    const { show, text, click } = actions.ok;

    if (!show) {
      return null;
    }

    return (
      <OkButton onClick={click} className="btn text-white text-medium">
        {text}
      </OkButton>
    );
  }

  renderContent() {
    const { content } = this.state;
    return <span className="text-large text-light-gray2">{content}</span>;
  }

  render() {
    const { show, title } = this.state;
    const { dialog } = this.props;

    return (
      <MuiThemeProvider>
        <Dialog
          title={title}
          actions={[this.renderCancelBtn(), this.renderSubmitBtn()]}
          modal={true}
          open={show}
          onRequestClose={this.close}
          contentStyle={{ width: '95%', maxWidth: 560 }}
          bodyStyle={{ overflowY: 'visible' }}
          actionsContainerStyle={{
            padding: '0 20px 20px',
          }}
          autoScrollBodyContent
          {...dialog}>
          {this.renderContent()}
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

const OkButton = styled(BaseButton)`
  background-color: ${Colors.mainOrange};
`;

const CancelButton = styled(BaseButton)`
  background-color: #fff;
  border-color: #fff;
  color: inherit;

  &:hover {
    background-color: #f4f4f4;
    border-color: #f4f4f4;
  }
`;

AlertConfirmDialog.propTypes = {
  dialog: PropTypes.object,
};

AlertConfirmDialog.defaultProps = {
  dialog: {},
};

export default AlertConfirmDialog;
